import {
  CompanyCreationDocumentStatus,
  ShineStartDocumentStatus,
} from '../../../../../__generated__/GQL';

type DocumentStatus = `${CompanyCreationDocumentStatus}` &
  `${ShineStartDocumentStatus}`;

const getDocumentStatus = (status: DocumentStatus) => {
  if (status === 'REFUSED') {
    return 'error';
  }
  if (status === 'MISSING' || status === null) {
    return 'waiting';
  }
  if (status === 'VALIDATED') {
    return 'complete';
  }
  return 'pending';
};

export default getDocumentStatus;
